module.exports = __webpack_public_path__ + "img/cloud-instructs.0792c226.svg";